const messages = {
    availPoints: "Punti disponibili",
    awaitingPoints: "Punti in attesa",
  board: {
    title: "Dashboard",
    title2: "Animazione delle prestazioni {year}",
    headline1: "Le tue promozioni e i tuoi punti a colpo d'occhio",
    headline2: "Guadagna punti per i tuoi acquisti di pneumatici.",
    pointsBalanceToDate: "SALDO PUNTI AD OGGI",
    availPoints: "Punti disponibili",
    awaitingPoints: "Punti in attesa",
    yourRealisation: "I TUOI RISULTATI",
    yourEngagement: "Il tuo impegno annuale: <b>{tyres} pneumatici</b>",
    yourPoints: "I TUOI PUNTI",
    yourRetailPurchase: "I TUOI ACQUISTI AL DETTAGLIO",
    yourRetailPurchaseCCS: "LE TUE VENDITE AL DETTAGLIO",
    pointsByPurchase: "punti generati dai tuoi acquisti",
    pointsByBoosters: "punti generati dai booster",
    pointsByBSPurchase: "Punti generati dai tuoi acquisti Bridgestone",
    pointsByBSPurchaseCCS:
      "Punti generati dalle vendite dei tuoi pneumatici Bridgestone",
    remaining: "Pneumatici rimanenti",
    yourGoal: "Progresso dell'obiettivo",
    unit: "pneumatici",
    buttons: {
      learnMore: "Scopri di più sui tuoi punti",
      learnMoreAboutMechanism: "Scopri di più sulla meccanica",
    },
    charts: {
      byBrand: "Per marca",
      bySize: "Per dimensione<br/>del cerchio",
    },
    exploreResults: "Scopri i tuoi risultati",
    tyreLimitInfo:
      "Per ciascun periodo della campagna Booster è richiesto un volume minimo di 50 pneumatici Bridgestone e/o Firestone",
  },
  charts: {
    byBrand: "Per marca",
    bySize: "in base alla dimensione del cerchio",
  },

  dashboard: {
    dashboardTitle: "I tuoi vantaggi",
    dashboardBox: {
      title: "Saldo punti",
      description: "Totale dei tuoi attuali punti marketing",
      availPoints: "Punti disponibili",
      awaitingPoints: "Punti in attesa",
      lastUpdate: "Ultimo aggiornamento",
      button: "Saperne di più",
      points: "points",
    },
  },
  soldTyres: "PNEUMATICI VENDUTI",
  receivedPoints: "PUNTI GUADAGNATI",
  boosterCCS: {
    personalInfo: "Informazioni personali",
    csNumberTitle: "Si prega di specificare i numeri di conto partecipanti",
    tyresTitle: "Si prega di specificare il numero di pneumatici venduti",
    minTyresInfo:
      "È richiesto un minimo di {tyres} pneumatici Bridgestone/Firestone. Il risarcimento si applica solo ai pneumatici Bridgestone.",
    tyresAmount: "N. di pneumatici",
    filesTitle: "Carica la prova di vendita",
    filesDescription:
      "Nota: verranno prese in considerazione solo le vendite che specificano la dimensione del cerchione.",
    addAnotherFile: "Aggiungi un altro documento",
    file: "Carica documento",
    formatInfo:
      "Formati di file accettati: xlsx, jpeg e pdf. Dimensione massima del file: 8 MB",
    confrimationMessage:
      "<b>Grazie per la tua partecipazione!</b> <br/>La tua richiesta è stata ricevuta e inoltrata ai team Bridgestone per la convalida.<br/>Riceverai una notifica via email con i risultati della tua partecipazione a Booster CCS.<br/>A presto su Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Condividi punti",
    forShare: "Punti che condividerai",
    title: "Titolo",
  },
  notFoundFile: "Nessuno selezionato",
  chooseFile: "Scegli file",
};
export default {
  messages,
};
